$(document).ready(function () {
	jQuery.each(jQuery('[data-role="comparador"]'), function () {
		var form = this,
			$form = $(form),
			api_route = $form.attr('action');

			$form.submit(function(e){
				var formData = new FormData(this),
				form_serial = $(this).serializeArray(),
				form_array = {};

				$.each(form_serial, function (i, field) {
					form_array[field.name] = field.value;
				});

				$('[data-child="'+ form_array.child_num +'"]').addClass('waiting');
				$($form.find('select')).addClass('loading');
				
				$.ajax({
					url: api_route,
					type: 'POST',
					data: formData,
					dataType: "json",
					cache: false,
					contentType: false,
					processData: false
				}).done(function (response) {
					console.log(response);

					var especificaciones = response.especificaciones;
					var child_num = response.data_child;

					$.each(especificaciones, function (key, value) {
						if(value !== ''){
							$('[data-name="' + key + '"]').removeClass('hide');
						}
						$($('[data-name="' + key + '"]').find('[data-child="' + child_num + '"]')).html(value);
					});

					setTimeout( function()  {
						$('[data-child="'+ child_num +'"]').removeClass('waiting');
						$($form.find('select')).removeClass('loading');
					}, 1000);
				});

				e.preventDefault();
			});
	});
});